import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import AdminDashboard from './AdminDashboard';
import MarketsPage from './MarketsPage';
import MarketDetailsPage from './MarketDetailsPage';

const App = () => {
    const token = localStorage.getItem('token');

    return (
        <Router>
            <Routes>
                {/* Public login */}
                <Route path="/login" element={<LoginPage />} />

                {/* Admin routes (require token) */}
                <Route path="/admin" element={token ? <AdminDashboard /> : <Navigate to="/login" />} />
                <Route
                    path="/admin/packages/:packageName"
                    element={token ? <MarketsPage /> : <Navigate to="/login" />}
                />
                <Route
                    path="/admin/packages/:packageName/:marketName"
                    element={token ? <MarketDetailsPage /> : <Navigate to="/login" />}
                />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/admin" />} />
            </Routes>
        </Router>
    );
};

export default App;
